module.exports = __webpack_public_path__ + "static/img/wanDaContent4.ed175e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wanDaContent4.png
// module id = mhte
// module chunks = 2